import type {
    PartnerCockpitReimbursementReason,
    PartnerCockpitReimbursementState,
} from '@houzy/schemas/partner-cockpit/reimbursement';

const REASON_LABEL_KEYS: Record<PartnerCockpitReimbursementReason, string> = {
    TooManyCreditsBilled: 'REIMBURSEMENT.REASON.TOO_MANY_CREDITS_BILLED',
    CannotDoThisWork: 'REIMBURSEMENT.REASON.CANNOT_DO_THIS_WORK',
    NotEnoughCapacityOrOnHoliday: 'REIMBURSEMENT.REASON.NOT_ENOUGH_CAPACITY_OR_ON_HOLIDAY',
    UserIsTooFarAway: 'REIMBURSEMENT.REASON.USER_IS_TOO_FAR_AWAY',
    UserNotReachable: 'REIMBURSEMENT.REASON.USER_NOT_REACHABLE',
    UserNotInterested: 'REIMBURSEMENT.REASON.USER_NOT_INTERESTED',
    LanguageBarrier: 'REIMBURSEMENT.REASON.LANGUAGE_BARRIER',
};

const STATE_LABEL_KEYS: Record<PartnerCockpitReimbursementState, string> = {
    Requestable: 'REIMBURSEMENT.BUTTON.REQUESTABLE',
    Requested: 'REIMBURSEMENT.BUTTON.REQUESTED',
    Approved: 'REIMBURSEMENT.BUTTON.APPROVED',
    Declined: 'REIMBURSEMENT.BUTTON.DECLINED',
};

export function reimbursementReasonLabelKey(reason: PartnerCockpitReimbursementReason): string {
    return REASON_LABEL_KEYS[reason];
}

export function reimbursementStateLabelKey(state: PartnerCockpitReimbursementState): string {
    return STATE_LABEL_KEYS[state];
}

// What the overview reports: a pending or decided request. `Requestable` is a call to action, which
// lives on the detail page only.
export type ReimbursementOutcome = Exclude<PartnerCockpitReimbursementState, 'Requestable'>;

export function reimbursementOutcome(
    state: PartnerCockpitReimbursementState | undefined,
): ReimbursementOutcome | undefined {
    return state === undefined || state === 'Requestable' ? undefined : state;
}

export function reimbursementReasonUnavailableKey(reason: PartnerCockpitReimbursementReason): string {
    return reason === 'UserNotReachable'
        ? 'REIMBURSEMENT.REASON.UNAVAILABLE_TOO_EARLY'
        : 'REIMBURSEMENT.REASON.UNAVAILABLE';
}
